<script setup lang="ts">
  import {RouterLink} from "vue-router";
  import {Model} from "@/app/Model";
  let model: Model = Model.getReactiveInstance()

  declare let gtagO: Function;
  declare let frontendConfig: any;

  function setgtagO(): void {
    gtagO({
      event: 'outboundlink', 
      target: 'http://www.dejure.it',
      posizione: 'top HP'
    })
  }

  function isRebranding(): boolean {
    return frontendConfig.rebranding;
  }
</script>

<template>
  <div class="container-fluid border-bottom testata">
    <div class="row ">
      <div class="col-md-4 col-12 p-3">
        <RouterLink to="/">
          <img v-if="!isRebranding()" alt="Home" class="logo" src="../../assets/logo.svg" />
          <img v-if="isRebranding()" alt="Home" class="logo" src="../../assets/LOGO_STRATEGIA.png" />
        </RouterLink>
      </div>
      <div class="col-md-6 col-8 p-4 px-1 text-center testataButtons">
        <RouterLink to="/admin" class="btn btn-error" v-if="model.isAdmin"><i class="bi bi-pen"></i> &nbsp; Admin</RouterLink>
      </div>
      <div class="col-md-2 col-4 text-right p-4 px-2">
        <a class="btn btn-primary" href="http://www.dejure.it" target="_blank" @click="setgtagO()">Vai a Dejure</a>
      </div>
    </div>
  </div>
</template>